<div class="content-wrapper">
  <div class="col-12 grid-margin stretch-card">
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">Create Labour Request Form</h4>
        <form class="forms-sample" #ngNewContractForm="ngForm" name="form"
          (ngSubmit)="ngNewContractForm.form.valid && onSubmit()" >

          <div class="row">
            <!-- Location  
           
              <div class="form-group">
                <label for="location">Location</label>
                <select class="form-control" required [(ngModel)]="selectedLocationId" name="selectedLocationId"
                  id="selectedLocationId">
                  <option value="">--Select Location--</option>
                  <option [value]="location.id" *ngFor="let location of Locations">{{location.name}} </option>
                </select>              
              </div>
            </div>                        
-->
            <!-- Cost Center  -->
            <div class="col">
              <div class="form-group">
                <label for="costCenter">Cost Center</label>
                <ng-select [(ngModel)]="selectedCostCenterId" id="selectedCostCenterId" name="selectedCostCenterId">
                  <ng-option *ngFor="let costCenter of CostCenters" [value]="costCenter.id">{{costCenter.code}} -
                    {{costCenter.name}}</ng-option>
                </ng-select>
              </div>
            </div>

              <!-- Function  -->
              <div class="col">
                <div class="form-group">
                  <label for="selectedfunction">Function</label>
                  <select class="form-control" required [(ngModel)]="functionId" name="functionId"
                    id="functionId"  (ngModelChange)="onChangeFunction($event)">
                    <option value="">-- Select Function --</option>
                    <option [value]="department.id" *ngFor="let department of Departments">{{department.name}}
                    </option>
                  </select>
                  
                </div>
              </div>

          </div>

          <div class="row">
            <!-- Number of Staff  -->
            <div class="col">
              <div class="form-group">
                <label for="exampleInputCity1">Number of Staff</label>
                <input type="number" class="form-control" id="noOfStaff" placeholder="Number of staff needed"
                  name="noOfStaff" [(ngModel)]="noOfStaff" required #EnoOfStaff="ngModel">
                <div class="alert alert-danger" role="alert" *ngIf="ngNewContractForm.submitted && EnoOfStaff.errors">
                  At least 1 staff is required!
                </div>
              </div>
            </div>

             <!-- Mode Of Head Count  -->
              <div class="col">
                <div class="form-group">
                  <label for="selectedMode">Mode Of HeadCount</label>
                  <select class="form-control" required [(ngModel)]="modeOfHeadCount" name="modeOfHeadCount"
                    id="modeOfHeadCount"  (ngModelChange)="onChangeMode($event)">
                    <option value="">-- Select Mode --</option>
                    <option [value]="mode.option" *ngFor="let mode of modeOfHeadCountDropdown">{{mode.option}}
                    </option>
                  </select>
                  
                </div>
              </div>

            <!-- Total Cost  -->
            <div class="col">
              <div class="form-group">
                <label for="exampleInputCity1">Budget Cost</label>
                <input type="number" class="form-control" id="totalCost" placeholder="Total cost of contract"
                  name="totalCost" [(ngModel)]="totalCost" required #EtotalCost="ngModel">
                <div class="alert alert-danger" role="alert" *ngIf="ngNewContractForm.submitted && EtotalCost.errors">
                  Cost is required!
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <!-- Contract Duration  -->
            <div class="col">
              <div class="form-group">
                <label for="exampleInputCity1">Contract Duration (Month)</label>
                <input type="number" class="form-control" id="contractDuration" placeholder="ex: 14 months"
                  name="contractDuration" [(ngModel)]="contractDuration" required #EcontractDuration="ngModel">
                <div class="alert alert-danger" role="alert"
                  *ngIf="ngNewContractForm.submitted && EcontractDuration.errors">
                  Duration is required!
                </div>
              </div>
            </div>

             <!-- request Tpe  -->
              <div class="col">
                <div class="form-group">
                  <label for="selectedMode">Request Type</label>
                  <select class="form-control" required [(ngModel)]="renewalOrNew" name="renewalOrNew"
                    id="renewalOrNew"  (onChangeModetype)="onChangeMode($event)">
                    <option value="">-- Select Type --</option>
                    <option [value]="mode.option" *ngFor="let mode of requestTypeDropdown">{{mode.option}}
                    </option>
                  </select>
                  
                </div>
              </div>


            <!-- Expected Start Date  -->
            <!-- <div class="col">
              <div class="form-group">
                <label for="exampleInputCity1">Expected Start Date</label>
                <input type="date" class="form-control" id="expectedStartDate" placeholder="" name="expectedStartDate"
                  min="{{ expectedStartDate | date: 'yyyy-MM-dd' }}" [(ngModel)]="expectedStartDate" required
                  #EexpectedStartDate="ngModel">
                <div class="alert alert-danger" role="alert"
                  *ngIf="ngNewContractForm.submitted && EexpectedStartDate.errors">
                  Date is required!
                </div>
              </div>
            </div> -->
            <div class="col">
              <div class="form-group">
                <label for="exampleInputCity1">Expected Start Date</label>
                <input type="date" class="form-control" id="expectedStartDate" placeholder="" name="expectedStartDate"
                  [(ngModel)]="expectedStartDate" required #EexpectedStartDate="ngModel">
                <div class="alert alert-danger" role="alert"
                  *ngIf="ngNewContractForm.submitted && EexpectedStartDate.errors">
                  Date is required!
                </div>
              </div>
            </div>

          </div>


          <div class="row">
            <!-- Description  -->
            <div class="col">
              <div class="form-group">
                <label for="exampleTextarea1">Job Description</label>
                <textarea class="form-control" id="description" rows="4" name="description" [(ngModel)]="description"
                  required #Edescription="ngModel"></textarea>

                <div class="alert alert-danger" role="alert" *ngIf="ngNewContractForm.submitted && Edescription.errors">
                  Description is required!
                </div>
              </div>
            </div>

            <!-- Justification  -->
            <div class="col">
              <div class="form-group">
                <label for="justification">Justification</label>
                <textarea class="form-control" id="justification" rows="4" name="justification"
                  [(ngModel)]="justification" required #Ejustification="ngModel"></textarea>

                <div class="alert alert-danger" role="alert"
                  *ngIf="ngNewContractForm.submitted && Ejustification.errors">
                  Justification is required!
                </div>
              </div>
            </div>

            <!-- Qualification  -->
            <div class="col">
              <div class="form-group">
                <label for="justification">Qualification & Experience</label>
                <textarea class="form-control" id="qualification" rows="4" name="qualification"
                  [(ngModel)]="qualification" required #Equalification="ngModel"></textarea>

                <div class="alert alert-danger" role="alert"
                  *ngIf="ngNewContractForm.submitted && Equalification.errors">
                  Qualification is required!
                </div>
              </div>
            </div>
          </div>

          <hr>
        
            <div class="class=col-lg-6 grid-margin">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Approvals</h4>
              
                  
                    <table class="table table-bordered ">
                      
                      <tbody>
                        <tr class="table-info">
                          <td>
                            1
                          </td>
                          <td>
                           Unit Head
                          </td>
                          <td>
                            <ng-select  required [(ngModel)]="selectedManagerId"  id="selectedManagerId"  name="selectedManagerId">
                              <ng-option *ngFor="let manager of Managers" [value]="manager.email">
                                {{manager.firstName}} -   {{manager.email}}</ng-option>
                            </ng-select>
                      
                               <!-- error block -->
        <div class="alert alert-danger" *ngIf="ngNewContractForm.submitted && selectedManagerId.length==0">
          <sup>*</sup>Please provide Unit Head to approve
        </div>
                          </td>
                       
                        </tr>


                        <tr  *ngIf="isShowPlantManager" class="table-danger">
                          <td>
                            2
                          </td>
                          <td>
                         Plant Manager
                          </td>
                          <td>
                            <ng-select  required [(ngModel)]="selectedPlantManagerId"  id="selectedPlantManagerId" name="selectedPlantManagerId">
                              <ng-option *ngFor="let plant of PlantManagers" [value]="plant.email">
                                {{plant.firstName}} -   {{plant.email}}</ng-option>
                            </ng-select>
    
    <!-- error block -->
    <div class="alert alert-danger" *ngIf="ngNewContractForm.submitted && selectedfunctionalDirectorId.length==0">
    <sup>*</sup>Please provide Functional Director to approve
    </div>
    
                          </td>
                       
                        </tr>


                        <tr class="table-warning">
                          <td>
                            {{hrbpCount}}
                          </td>
                          <td>
                         HRBP
                          </td>
                          <td>
                            <ng-select  required [(ngModel)]="selectedhrbpId"  id="selectedhrbpId" name="selectedhrbpId">
                              <ng-option *ngFor="let hrbp of HRBPS" [value]="hrbp.email">
                                {{hrbp.firstName}} -   {{hrbp.email}}</ng-option>
                            </ng-select>

                      <!-- error block -->
                      <div class="alert alert-danger" *ngIf="ngNewContractForm.submitted && selectedhrbpId.length==0">
                        <sup>*</sup>Please provide HRBP to approve
                      </div>

                          </td>
                        
                        </tr>
                        <tr class="table-danger">
                          <td>
                            {{funcdirectorCount}}
                          </td>
                          <td>
                          Functional Director
                          </td>
                          <td>
                            <ng-select  required [(ngModel)]="selectedfunctionalDirectorId"  id="selectedfunctionalDirectorId" name="selectedfunctionalDirectorId">
                              <ng-option *ngFor="let director of FunctionalDirectors" [value]="director.email">
                                {{director.firstName}} -   {{director.email}}</ng-option>
                            </ng-select>

  <!-- error block -->
  <div class="alert alert-danger" *ngIf="ngNewContractForm.submitted && selectedfunctionalDirectorId.length==0">
    <sup>*</sup>Please provide Functional Director to approve
  </div>

                          </td>
                       
                        </tr>
                        <tr class="table-success">
                          <td>
                            {{procurementDirector}}
                          </td>
                          <td>
                           Procurement Director
                          </td>
                          <td>
                            {{procurementDirectorToApprove}}
                          </td>
                        
                        </tr>


                        <tr class="table-primary">
                          <td>
                            {{hrCount}}
                          </td>
                          <td>
                         O & HR Director
                          </td>
                          <td>
                            {{ohrdToApprove}}
                          </td>
                        
                        </tr>
                      </tbody>
                    </table>
                 
                </div>
              </div>
            </div>
          <hr>
          <button type="submit" class="btn btn-primary mr-2">Submit</button>
          <button class="btn btn-light">Cancel</button>
        </form>
      </div>
    </div>
  </div>